import * as React from 'react';
import { MouseEventHandler, ReactChildren } from 'react';

type IconButtonProps = {
    onClick: MouseEventHandler<HTMLDivElement>,
    icon: string,
    label: string,
    className?: string,
    children?: ReactChildren,
};

export function IconButton({ icon, label, className, children, onClick }: IconButtonProps) {
    return <div
        className={`icon-button ${icon && 'icon-button_with-icon'} ${!!label && 'icon-button_no-text'} ${className}`}
        onClick={onClick}>
        {!!icon &&
            <i className={`icon icon-alan-${icon} icon-button__icon`} />
        }
        {label}
        {children}
    </div>;
}